import { AxiosError } from "axios";
import { AppRoutes } from "@/constants/routes";
import { NavigateFunction } from "react-router-dom";
import { toaster } from "@/components/ui/toaster";

export async function handlePermissionError(
  error: unknown,
  navigate: NavigateFunction,
  fetchPermissions?: () => Promise<void>,
  route?: string,
  routeState?: any,
): Promise<boolean> {
  const errorObj = error as AxiosError<{
    message: string;
    tiposFaltantes?: string[];
  }>;
  const missingPermissions = errorObj.response?.data?.tiposFaltantes;

  if (errorObj.response?.status === 403 && missingPermissions?.length) {
    if (missingPermissions.includes("R")) {
      // Falta lectura → ir a pantalla de "sin permiso"
      await fetchPermissions?.();
      navigate(AppRoutes.NO_PERMISSION);
      return true;
    } else if (missingPermissions.includes("W")) {
      // Falta escritura → ir al listado
      toaster.create({
        type: "error",
        title: "No tienes permiso para realizar esta acción.",
      });

      await fetchPermissions?.();
      navigate(route ?? "#", { state: routeState });
      return true;
    }
  }
  return false;
}

